<template>
<div class="customers">
  <row>
    <div class="sl-col-4">
      <div class="sl-condition">
        <row>
          <div class="col-md-12">
            <div class="form-group">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('Views.Customers.checkbox.all')}}</el-checkbox>
              <el-checkbox-group v-model="checkList" @change="handleCheckedChange">
                <div class="flex">
                  <el-checkbox label="1">{{$tc('Views.Customers.checkbox.activeCustomers',0)}}</el-checkbox>
                  <el-checkbox label="2">{{$tc('Views.Customers.checkbox.activeCustomers',1)}}</el-checkbox>
                  <el-checkbox label="3">{{$tc('Views.Customers.checkbox.activeCustomers',2)}}</el-checkbox>
                </div>
                <div class="flex">
                  <el-checkbox label="4">{{$tc('Views.Customers.checkbox.frequencyCustomers',0)}}</el-checkbox>
                  <el-checkbox label="5">{{$tc('Views.Customers.checkbox.frequencyCustomers',1)}}</el-checkbox>
                  <el-checkbox label="6">{{$tc('Views.Customers.checkbox.frequencyCustomers',2)}}</el-checkbox>
                </div>
                <div class="flex">
                  <el-checkbox label="7">{{$tc('Views.Customers.checkbox.contributionCustomers',0)}}</el-checkbox>
                  <el-checkbox label="8">{{$tc('Views.Customers.checkbox.contributionCustomers',1)}}</el-checkbox>
                  <el-checkbox label="9">{{$tc('Views.Customers.checkbox.contributionCustomers',2)}}</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
        </row>
        <row>
          <div class="col-md-6">
            <div class="form-group">
              <div class="btn btn-success btn-flat" @click="searchByCondition">{{$t('Functional.confirm')}}</div>
              <div class="btn btn-danger btn-flat " @click="clearSelectors">{{$t('Functional.clear')}}</div>
            </div>
          </div>
        </row>
      </div>
    </div>
  </row>
  <row>
    <div class="sl-col-4">
      <div class="sl-body" v-loading="loading">
        <el-table :data="tableData" style="width: 100%" @sort-change="handleSortChange" border>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="id" :label="$t('Views.Customers.table.id')" sortable width="80"> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="name" :label="$t('Views.Customers.table.name')" sortable> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="phone" :label="$t('Views.Customers.table.mobile')" sortable> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="gender" :label="$t('Views.Customers.table.gender')"> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="joinTime" :label="$t('Views.Customers.table.joinDate')"> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="totalAmount" :label="$t('Views.Customers.table.totalSpending')"> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="lastVisitTime" :label="$t('Views.Customers.table.lastVisitDate')"> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="avgAmount" :label="$t('Views.Customers.table.averageSpending')"> </el-table-column>
        </el-table>
      </div>
    </div>
  </row>
</div>
</template>
<style scoped>
.checkList {
  padding: 10px 0 10px 0;
  border-top: 1px solid #d7d7d7;
}
</style>
<script>
import api from '../../api'
const defaultOp = ['1', '2', '3', '4', '5', '6', '7', '8', '9']
export default {
  name: 'Customers',
  data() {
    return {
      loading: false,
      checkList: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      checkAll: true,
      options: defaultOp,
      isIndeterminate: false,
      tableData: [],
      table: {
        total: 0,
        page: 1,
        per: 10,
        order: '',
        orderBy: ''
      },
      condition: {
        type: ''
      }
    }
  },
  created() {
    updateTable(this)
  },
  methods: {
    handleSizeChange(per) {
      let param = Object.assign({}, initParams(this.table, this.condition, this))
      param.per = per
      updateTable(this, param)
    },
    handleCurrentChange(page) {
      let param = Object.assign({}, initParams(this.table, this.condition, this))
      param.page = page
      updateTable(this, param)
    },
    handleSortChange({
      column,
      prop,
      order
    }) {
      let param = Object.assign({}, initParams(this.table, this.condition, this))
      param.order = order === null ? '' : order === 'descending' ? 'DESC' : 'ASC'
      param.orderBy = prop === null ? '' : prop
      updateTable(this, param)
    },
    handleCheckAllChange(event) {
      this.checkList = event.target.checked ? defaultOp : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.options.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.options.length
    },
    searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Customers')
      updateTable(this, initParams(this.table, this.condition, this))
    },
    clearSelectors() {
      this.$ga.event('Button', 'ClearAll', 'Customers')
      this.isIndeterminate = false
      this.checkList = []
      this.checkAll = false
    }
  }
}
// 更新表单 。 默认每页10条，页码为1
function updateTable(vm, params = {
  per: 10,
  page: 1,
  type: defaultOp.join(',')
}) {
  vm.loading = true
  api.FetchCustomerTable(params).then(res => {
    const result = res.data.data
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per,
      order: result.order,
      orderBy: result.orderBy
    }
    vm.tableData = result.list
    vm.loading = false
  })
}

function initParams(table, condition, vm) {
  let tb = JSON.parse(JSON.stringify(table))
  let cd = JSON.parse(JSON.stringify(condition))
  delete tb.total
  cd.type = vm.checkList.join(',')
  return Object.assign({}, tb, cd)
}
</script>



// WEBPACK FOOTER //
// customers.vue?aaf21b0e